import { EngineType } from "../types";
import { store, engineTypesAtom, EngineTypesMap } from "../store";

// 特定のエンジンが契約されているかチェック
export function isEngineContracted(engineType: EngineType): boolean {
  const engineTypes: EngineTypesMap = store.get(engineTypesAtom);

  return engineTypes[engineType as keyof EngineTypesMap] === true;
}
